import * as i0 from '@angular/core';
import { Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import '@tn-equis/core/utils';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@tn-equis/core/components/sticker-animation';
import { EquisStickerAnimationModule } from '@tn-equis/core/components/sticker-animation';

var NGZRowsDetailsTotalContainerSize;
(function (NGZRowsDetailsTotalContainerSize) {
    NGZRowsDetailsTotalContainerSize["SMALL"] = "small";
    NGZRowsDetailsTotalContainerSize["MEDIUM"] = "medium";
    NGZRowsDetailsTotalContainerSize["LARGE"] = "large";
    NGZRowsDetailsTotalContainerSize["EXTRA_LARGE"] = "extra-large";
})(NGZRowsDetailsTotalContainerSize || (NGZRowsDetailsTotalContainerSize = {}));

class EquisLoadingComponent {
    constructor() {
        this.containerSize = NGZRowsDetailsTotalContainerSize.SMALL;
    }
    set size(size) {
        this.containerSize = Object.values(NGZRowsDetailsTotalContainerSize).includes(size)
            ? size
            : NGZRowsDetailsTotalContainerSize.SMALL;
    }
}
EquisLoadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisLoadingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisLoadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisLoadingComponent, selector: "z-loading , equis-loading ", inputs: { message: "message", size: "size" }, ngImport: i0, template: "<div class=\"loading\">\n  <div class=\"loading__sticker-wrapper\">\n    <div\n      class=\"loading__sticker\"\n      [ngClass]=\"'loading__sticker--' + containerSize\"\n    >\n      <equis-sticker-animation\n        [autoPlay]=\"true\"\n        [loop]=\"true\"\n        [width]=\"48\"\n        [height]=\"11\"\n        [path]=\"'./assets/stickers/loader/loader-dots-medium.json'\"\n      >\n      </equis-sticker-animation>\n    </div>\n  </div>\n  <p class=\"z-body-1-medium\" *ngIf=\"message\">{{ message }}</p>\n</div>\n", styles: [".loading{align-items:center;display:flex;flex-direction:column;width:100%}.loading__sticker-wrapper{align-items:center;display:flex;height:48px}.loading__sticker--medium{transform:scale(1.25)}.loading__sticker--large{transform:scale(1.5)}.loading__sticker--extra-large{transform:scale(1.75)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.EquisStickerAnimationComponent, selector: "z-sticker-animation, equis-sticker-animation", inputs: ["autoPlay", "loop", "path", "width", "height"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisLoadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-loading , equis-loading ', template: "<div class=\"loading\">\n  <div class=\"loading__sticker-wrapper\">\n    <div\n      class=\"loading__sticker\"\n      [ngClass]=\"'loading__sticker--' + containerSize\"\n    >\n      <equis-sticker-animation\n        [autoPlay]=\"true\"\n        [loop]=\"true\"\n        [width]=\"48\"\n        [height]=\"11\"\n        [path]=\"'./assets/stickers/loader/loader-dots-medium.json'\"\n      >\n      </equis-sticker-animation>\n    </div>\n  </div>\n  <p class=\"z-body-1-medium\" *ngIf=\"message\">{{ message }}</p>\n</div>\n", styles: [".loading{align-items:center;display:flex;flex-direction:column;width:100%}.loading__sticker-wrapper{align-items:center;display:flex;height:48px}.loading__sticker--medium{transform:scale(1.25)}.loading__sticker--large{transform:scale(1.5)}.loading__sticker--extra-large{transform:scale(1.75)}\n"] }]
        }], propDecorators: { message: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class EquisLoadingModule {
    static forRoot() {
        return {
            ngModule: EquisLoadingModule,
        };
    }
}
EquisLoadingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisLoadingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisLoadingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisLoadingModule, declarations: [EquisLoadingComponent], imports: [CommonModule, EquisStickerAnimationModule], exports: [EquisLoadingComponent] });
EquisLoadingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisLoadingModule, imports: [CommonModule, EquisStickerAnimationModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisLoadingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisLoadingComponent],
                    imports: [CommonModule, EquisStickerAnimationModule],
                    exports: [EquisLoadingComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
                }]
        }] });

/*
 * Public API Surface of equis-message
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisLoadingComponent, EquisLoadingModule };
